import { Scene } from "../../tools/Scene";
import { TitleScene } from "./TitleScene";
import { Button } from "../../ui/Button";
import { LocalizationManager } from "../../managers/LocalizationManager";
import { MuteButton } from "./MuteButton";
import { GameType } from "../../models/CBNGameModel";

export class LetteratiTitle{

    glow:Phaser.GameObjects.Sprite|null = null;
    gizmo:Phaser.GameObjects.Sprite|null = null;
    superbook:Phaser.GameObjects.Sprite|null = null;
    e:Phaser.GameObjects.Sprite|null = null;
    z:Phaser.GameObjects.Sprite|null = null;
    letter:Phaser.GameObjects.Sprite|null = null;
    a:Phaser.GameObjects.Sprite|null = null;
    t:Phaser.GameObjects.Sprite|null = null;
    i:Phaser.GameObjects.Sprite|null = null;

    scene:Scene;
    group:Phaser.GameObjects.Group;

    constructor(scene:Scene){
        this.scene = scene;
        

        let image:Phaser.GameObjects.Image;
        let sprite:Phaser.GameObjects.Sprite;
        let button:Button;
        let position;
        let group = scene.add.group({});
        this.group = group;

        position = scene.scaleManager.getRelativePosition(0.5,0.5);

        this.glow = scene.add.sprite(position.x,position.y,'title_glow');

        this.gizmo = scene.add.sprite(position.x,position.y,'title_la_gizmo');
        this.a = scene.add.sprite(position.x,position.y,'title_la_a');
        this.t = scene.add.sprite(position.x,position.y,'title_la_t');
        this.i = scene.add.sprite(position.x,position.y,'title_la_i');

        this.superbook = scene.add.sprite(position.x,position.y-400,'title_superbook');
        this.e = scene.add.sprite(position.x-50,position.y-150,'title_la_gizmo_e');
        this.z = scene.add.sprite(position.x,position.y+100,'title_la_gizmo_z');
        this.letter = scene.add.sprite(position.x,position.y,'title_la_letter');
        
        group.add(this.glow);
        group.add(this.gizmo);
        group.add(this.a);
        group.add(this.t);
        group.add(this.i);
        group.add(this.superbook);
        group.add(this.e);
        group.add(this.z);
        group.add(this.letter);

        Phaser.Actions.SetAlpha(this.group.getChildren(),0);
        let startingScale = scene.scaleManager.isOrientationLandscape() ? 1 : .7;
        let timeline = scene.tweens.createTimeline({});
        timeline.add({
            targets: this.group.getChildren(),
            scaleX: 0.01,
            scaleY: 0.01,
            //alpha: 1,
            duration: 1
        });
        timeline.add({
            targets: this.letter,
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
        });
        timeline.add({
            targets: this.a,
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
            delay: 0,
            offset: '-= 100'
        });
        timeline.add({
            targets: this.t,
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
            delay: 0,
            offset: '-= 150'
        });
        timeline.add({
            targets: this.i,
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
            delay: 0,
            offset: '-= 200'
        });

        timeline.play();
        timeline = scene.tweens.createTimeline({});
        
        timeline.add({
            targets: [this.gizmo,this.glow],
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
            delay: 200
        });
        timeline.add({
            targets: this.superbook,
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
        });
        
        let ePosition;
        let zPosition;

        if(this.scene.scaleManager.isOrientationLandscape()){
            position = this.scene.scaleManager.getRelativePosition(0.5,0.5);
            position.x -= 270;
            position.y -= 120;
            ePosition = position;
            position = this.scene.scaleManager.getRelativePosition(0.5,0.5);
            position.x += 270;
            position.y -= 120;
            zPosition = position;
        }else{
            position = this.scene.scaleManager.getRelativePosition(0.5,0.4);
            position.x -= 200;
            position.y -= 90;
            ePosition = position;
            position = this.scene.scaleManager.getRelativePosition(0.5,0.4);
            position.x += 200;
            position.y -= 90;
            zPosition = position;
        }
        timeline.add({
            targets: this.e,
            y: '-=1000',
            duration: 100,
        });
        timeline.add({
            targets: this.e,
            y: ePosition.y,
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
        });
        timeline.add({
            targets: this.z,
            y: '-=1000',
            duration: 100,
        });
        timeline.add({
            targets: this.z,
            y: zPosition.y,
            scaleX: startingScale,
            scaleY: startingScale,
            alpha: 1,
            ease: 'Power3',
            duration: 200,
        });
        
        scene.tweens.add({
            targets: this.glow,
            scaleX: 0.75,
            scaleY: 0.75,
            duration: 2000,
            ease: 'Power1',
            yoyo:true,
            loop: -1
        });

        timeline.play();
    }

    reorient(landscape:boolean){
        let position;
        if(landscape){

            Phaser.Actions.SetScale(this.group!.getChildren(),1,1);
            position = this.scene.scaleManager.getRelativePosition(0.5,0.5);
            
            this.glow!.setPosition(position.x,position.y);
            this.superbook!.setPosition(position.x,position.y-200);

            this.gizmo!.setPosition(position.x,position.y-50);
            this.e!.setPosition(position.x-270,position.y-120);
            this.e!.setRotation((-2 * Math.PI)/25);
            this.z!.setPosition(position.x+270,position.y-120);
            this.z!.setRotation((2 * Math.PI)/25);

            this.letter!.setPosition(position.x-200,position.y+80);
            this.a!.setPosition(position.x+120,position.y+80);
            this.t!.setPosition(position.x+245,position.y+80);
            this.i!.setPosition(position.x+370,position.y+80);
        }else{
            Phaser.Actions.SetScale(this.group!.getChildren(),.7,.7);
            position = this.scene.scaleManager.getRelativePosition(0.5,0.4);
            
            this.glow!.setPosition(position.x,position.y);
            this.superbook!.setPosition(position.x,position.y-150);

            this.gizmo!.setPosition(position.x,position.y-40);
            this.e!.setPosition(position.x-200,position.y-90);
            this.e!.setRotation((-2 * Math.PI)/25);
            this.z!.setPosition(position.x+200,position.y-90);
            this.z!.setRotation((2 * Math.PI)/25);

            this.letter!.setPosition(position.x-140,position.y+60);
            this.a!.setPosition(position.x+80,position.y+60);
            this.t!.setPosition(position.x+170,position.y+60);
            this.i!.setPosition(position.x+260,position.y+60);
        }
    }

    
}